(function () {
    if (window.location.pathname !== '/user/bookings') return;

    $('.feedback, .other').on('click', function (e) {
        e.preventDefault();

        $(this).parent('form').submit();
    });
})();
